__turbopack_context__.v({
  "Border": "Icon-module-scss-module__RycweW__Border",
  "HasBackground": "Icon-module-scss-module__RycweW__HasBackground",
  "Icon": "Icon-module-scss-module__RycweW__Icon",
  "Inner": "Icon-module-scss-module__RycweW__Inner",
  "IsBlack": "Icon-module-scss-module__RycweW__IsBlack",
  "IsBlue": "Icon-module-scss-module__RycweW__IsBlue",
  "IsFadedBlue": "Icon-module-scss-module__RycweW__IsFadedBlue",
  "IsGrey": "Icon-module-scss-module__RycweW__IsGrey",
  "IsMediumGrey": "Icon-module-scss-module__RycweW__IsMediumGrey",
  "IsWhite": "Icon-module-scss-module__RycweW__IsWhite",
  "Large": "Icon-module-scss-module__RycweW__Large",
  "Medium": "Icon-module-scss-module__RycweW__Medium",
  "Micro": "Icon-module-scss-module__RycweW__Micro",
  "Mirror": "Icon-module-scss-module__RycweW__Mirror",
  "Rounded": "Icon-module-scss-module__RycweW__Rounded",
  "Small": "Icon-module-scss-module__RycweW__Small",
  "Tiny": "Icon-module-scss-module__RycweW__Tiny",
  "XLarge": "Icon-module-scss-module__RycweW__XLarge",
  "XXLarge": "Icon-module-scss-module__RycweW__XXLarge",
});
